import { get as _get } from "lodash";
import api from "../../helpers/api";

export const doPasswordChange = (variables) => {
  return api().patch("/user/password", variables).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "data.responseMessage", "Something went wrong while changing password."),
      data: {},
    };
  });
};

export const doChangeProfileImg = async (variables) => {
  return api().patch("/user/profile_image", variables).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "data.responseMessage", "Something went wrong while uploading profile image."),
      data: {},
    };
  });
};

export const requestOnboardingAccess = (variables) => {
  return api().post("/User/onboarding/request", variables).then((res) => {
    return {
      flag: _get(res, "data.responseStatus", false),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", null),
    };
  }).catch((err) => {
    const fromApi = _get(err, "response.data.responseMessage", _get(err, "response.data.message", ""));
    return {
      flag: false,
      message:
        fromApi ||
        "We could not submit your request. Please check your connection, try again in a few minutes, or contact Funnel Fuel support.",
      data: null,
    };
  });
};
